import { SupportTicketEmailStatus } from "../models/enums/SupportTicketEmailStatus";
import { SupportTicketPriority } from "../models/enums/SupportTicketPriority";

type BadgeVariant = "success" | "warning" | "destructive" | "neutral";

const EMAIL_STATUS_VARIANTS: Record<SupportTicketEmailStatus, BadgeVariant> = {
  [SupportTicketEmailStatus.SENT]: "success",
  [SupportTicketEmailStatus.PENDING]: "warning",
  [SupportTicketEmailStatus.FAILED]: "destructive",
};

const PRIORITY_VARIANTS: Record<SupportTicketPriority, BadgeVariant> = {
  [SupportTicketPriority.HIGH]: "destructive",
  [SupportTicketPriority.MID]: "warning",
  [SupportTicketPriority.LOW]: "neutral",
};

export function getEmailStatusVariant(emailStatus: SupportTicketEmailStatus): BadgeVariant {
  return EMAIL_STATUS_VARIANTS[emailStatus] ?? "neutral";
}

export function getPriorityVariant(priority: SupportTicketPriority): BadgeVariant {
  return PRIORITY_VARIANTS[priority] ?? "neutral";
}

export function getEmailStatusLabelKey(emailStatus: SupportTicketEmailStatus): string {
  return `support_tickets.email_statuses.${emailStatus.toLowerCase()}`;
}

export function getPriorityLabelKey(priority: SupportTicketPriority): string {
  return `support.priorities.${priority.toLowerCase()}`;
}

/** Only a failed send can be retried: the backend rejects anything else with a conflict. */
export function isRetryable(emailStatus: SupportTicketEmailStatus): boolean {
  return emailStatus === SupportTicketEmailStatus.FAILED;
}
